export const airportServices = {
    beginPlan: ['Начало (план)', 'Begin (plan)'],
    beginReal: ['Начало (факт)', 'Begin (real)'],
    cancelDeletion: ['Отменить удаление', 'Cancel deletion'],
    confirmDeleteServices: ['Вы уверены, что хотите удалить операцию?', 'Are you sure you want to delete operation?'],
    deleteOperation: ['Удалить операцию', 'Delete operation'],
    end: ['Конец', 'End'],
    endPlan: ['Окончание (план)', 'End (plan)'],
    endReal: ['Окончание (факт)', 'End (real)'],
    notExistOrLockOperations: ['Следующие операции не существуют или заблокированы:', 'The following operations do not exist or locked:'],
    priority: ['Приоритет', 'Priority'],
    quantity: ['Количество', 'Quantity'],
    serviceType: ['Тип операции', 'Service type'],
    single: ['Разовая', 'Single'],
    start: ['Начало', 'Start'],
};
